import { useUserStore } from '@/stores/user'

function redirectIfNotVector() {
  const user = useUserStore()
  if (user.data?.access?.vector !== true)
    window.location.href = import.meta.env.VITE_APP_URL
}

const adminTools = [

  {
    path: '/cowork-authorize',
    name: 'vector-cowork-authorize',
    component: () => import('@/pages/vector/CoworkAuthorizePage.vue'),
    meta: {
      title: 'Cowork Authorize',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/icd10-codes',
    name: 'vector-admin-tools-icd10-codes-home',
    component: () => import('@/pages/vector/admin-tools/icd10-codes/Icd10CodesPage.vue'),
    meta: {
      title: 'ICD Codes',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/icd10-codes/new',
    name: 'vector-admin-tools-icd10-codes-new',
    component: () => import('@/pages/vector/admin-tools/icd10-codes/NewIcd10CodePage.vue'),
    meta: {
      title: 'New ICD10 Code',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/icd10-codes/:icdcode_id',
    name: 'vector-admin-tools-icd10-codes-detail',
    component: () => import('@/pages/vector/admin-tools/icd10-codes/Icd10CodeDetailPage.vue'),
    meta: {
      title: 'ICD10 Code Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/service-area-groups',
    name: 'vector-admin-tools-service-area-groups-home',
    component: () => import('@/pages/vector/admin-tools/service-area-groups/ServiceAreaGroupsPage.vue'),
    meta: {
      title: 'Service Area Groups',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/service-area-groups/new',
    name: 'vector-admin-tools-service-area-groups-new',
    component: () => import('@/pages/vector/admin-tools/service-area-groups/NewServiceAreaGroupPage.vue'),
    meta: {
      title: 'New Service Area Group',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/service-area-groups/:sag_id',
    name: 'vector-admin-tools-service-area-groups-detail',
    component: () => import('@/pages/vector/admin-tools/service-area-groups/ServiceAreaGroupDetailPage.vue'),
    meta: {
      title: 'Service Area Group Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/upload-configs',
    name: 'vector-admin-tools-upload-configs-home',
    component: () => import('@/pages/vector/admin-tools/upload-configs/UploadConfigsPage.vue'),
    meta: { title: 'Upload Configs', resource: 'Vector', action: 'read', subject: 'AdminTools' },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/upload-configs/:config_uuid',
    name: 'vector-admin-tools-upload-configs-detail',
    component: () => import('@/pages/vector/admin-tools/upload-configs/UploadConfigAdminDetailPage.vue'),
    meta: { title: 'Upload Config Detail', resource: 'Vector', action: 'read', subject: 'AdminTools' },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/outreach-scripts',
    name: 'vector-admin-tools-outreach-scripts-home',
    component: () => import('@/pages/vector/admin-tools/outreach-scripts/OutreachScriptsPage.vue'),
    meta: {
      title: 'Outreach Scripts',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/bulk-case-uploads',
    name: 'vector-admin-tools-bulk-case-uploads-home',
    component: () => import('@/pages/vector/admin-tools/bulk-case-upload/BulkCaseUploadsPage.vue'),
    meta: {
      title: 'Bulk Case Uploads',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/bulk-case-uploads/:uuid',
    name: 'vector-admin-tools-bulk-case-uploads-analytics',
    component: () => import('@/pages/vector/admin-tools/bulk-case-upload/analytics.vue'),
    meta: {
      title: 'Upload Analytics',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/funder-task-workflows',
    name: 'vector-admin-tools-funder-task-workflows-home',
    component: () => import('@/pages/vector/admin-tools/funder-task-workflows/FunderTaskWorkflowsPage.vue'),
    meta: {
      title: 'Funder Task Workflows',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/closed-lost-reasons',
    name: 'vector-admin-tools-closed-lost-reasons-home',
    component: () => import('@/pages/vector/admin-tools/closed-lost-reasons/ClosedLostReasonsPage.vue'),
    meta: {
      title: 'Closed Lost Reasons',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/attachment-categories',
    name: 'vector-admin-tools-attachment-categories-home',
    component: () => import('@/pages/vector/admin-tools/attachment-categories/AttachmentCategoriesPage.vue'),
    meta: {
      title: 'File Categories',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/customers',
    name: 'vector-admin-tools-customers-home',
    component: () => import('@/pages/vector/admin-tools/customers/CustomersPage.vue'),
    meta: {
      title: 'Customers',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/customers/:provider_uuid',
    name: 'vector-admin-tools-customers-detail',
    component: () => import('@/pages/vector/admin-tools/customers/CustomerDetailPage.vue'),
    meta: {
      title: 'Customer Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/eapr-audit',
    name: 'vector-admin-tools-eapr-audit-home',
    component: () => import('@/pages/vector/admin-tools/eapr-audit/EaprAuditPage.vue'),
    meta: {
      title: 'EAPR Audit',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/automation-runs',
    name: 'vector-admin-tools-automation-runs-home',
    component: () => import('@/pages/vector/admin-tools/automation-runs/AutomationRunsPage.vue'),
    meta: {
      title: 'Automation Runs',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },

  {
    path: '/vector/admin-tools/edi-ingestion-health',
    name: 'vector-admin-tools-edi-ingestion-health-home',
    component: () => import('@/pages/vector/admin-tools/edi-ingestion-health/EdiIngestionHealthPage.vue'),
    meta: {
      title: 'EDI Ingestion Health',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },

  {
    path: '/vector/admin-tools/eapr-auto-close-qa',
    name: 'vector-admin-tools-eapr-auto-close-qa-home',
    component: () => import('@/pages/vector/admin-tools/eapr-auto-close-qa/home.vue'),
    meta: {
      title: 'EAPR Auto-Close QA',
      action: 'read',
      subject: 'AdminTools',
    },
  },
  {
    path: '/vector/admin-tools/provider-advocate-assignments/home',
    name: 'vector-admin-tools-provider-advocate-assignments-home',
    component: () => import('@/pages/vector/admin-tools/provider-advocate-assignments/ProviderAdvocateAssignmentsPage.vue'),
    meta: {
      title: 'Provider Advocate Assignments',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/team-reporting/home',
    name: 'vector-admin-tools-team-reporting-home',
    component: () => import('@/pages/vector/admin-tools/team-reporting/TeamReportingPage.vue'),
    meta: {
      title: 'Team Reporting',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/billing-data-entry',
    name: 'vector-admin-tools-billing-data-entry-home',
    component: () => import('@/pages/vector/admin-tools/billing-data-entry/BillingDataEntryPage.vue'),
    meta: {
      title: 'Billing Data Entry',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/billing-review',
    name: 'vector-admin-tools-billing-review-home',
    component: () => import('@/pages/vector/admin-tools/billing-review/BillingReviewPage.vue'),
    meta: {
      title: 'Billing Review',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/invoice-export',
    name: 'vector-admin-tools-invoice-export-home',
    component: () => import('@/pages/vector/admin-tools/invoice-export/InvoiceExportPage.vue'),
    meta: {
      title: 'Invoice Export',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/quickbooks-upload',
    name: 'vector-admin-tools-quickbooks-upload-home',
    component: () => import('@/pages/vector/admin-tools/quickbooks-upload/QuickbooksUploadPage.vue'),
    meta: {
      title: 'QuickBooks Upload',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/provider-reporting',
    name: 'vector-admin-tools-provider-reporting-home',
    component: () => import('@/pages/vector/admin-tools/provider-reporting/ProviderReportingPage.vue'),
    meta: {
      title: 'Provider Reporting',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/referral-partner-reporting',
    name: 'vector-admin-tools-referral-partner-reporting-home',
    component: () => import('@/pages/vector/admin-tools/referral-partner-reporting/ReferralPartnerReportingPage.vue'),
    meta: {
      title: 'Referral Partner Reporting',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/enrollment-partner-reporting',
    name: 'vector-admin-tools-enrollment-partner-reporting-home',
    component: () => import('@/pages/vector/admin-tools/enrollment-partner-reporting/EnrollmentPartnerReportingPage.vue'),
    meta: {
      title: 'Enrollment Partner Reporting',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/reporting',
    name: 'vector-admin-tools-reporting-home',
    component: () => import('@/pages/vector/admin-tools/reporting/ReportingPage.vue'),
    meta: {
      title: 'Billing & Reporting',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/copay-configuration',
    name: 'vector-admin-tools-copay-configuration-home',
    component: () => import('@/pages/vector/admin-tools/copay-configuration/CopayConfigurationPage.vue'),
    meta: {
      title: 'Configuration',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/insurance-code-audit',
    name: 'vector-admin-tools-insurance-code-audit-home',
    component: () => import('@/pages/vector/admin-tools/insurance-code-audit/InsuranceCodeAuditPage.vue'),
    meta: {
      title: 'Insurance Code Audit',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
  {
    path: '/vector/admin-tools/insurance-code-audit/:providerUuid',
    name: 'vector-admin-tools-insurance-code-audit-detail',
    component: () => import('@/pages/vector/admin-tools/insurance-code-audit/InsuranceCodeAuditDetailPage.vue'),
    meta: {
      title: 'Insurance Code Audit — Provider Detail',
      resource: 'Vector',
      action: 'read',
      subject: 'AdminTools',
    },
    beforeEnter() {
      redirectIfNotVector()
    },
  },
]

export default adminTools
